import axios from "axios";

export const uploadAttachment = (
  fileName: string,
  file: any,
  sessionId: string | null
) => {
  const formData = new FormData();
  formData.append("name", fileName);
  formData.append("type", "binary");
  formData.append("datas", file);

  return axios
    .post(`${process.env.REACT_APP_BASE_URL}api/upload/image`, formData, {
      headers: {
        Authorization: `Bearer ${sessionId}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
